import {
    Mic, PartyPopper, Beer, Monitor, Landmark, GraduationCap,
    Trophy, Briefcase, UtensilsCrossed, ShoppingBag, Sparkles,
    Users, Presentation, Target, Palette, FlaskConical, BookOpen,
    Hammer, Dumbbell, Brain, Cpu, Baby, Megaphone, Map, Music,
    Drum, Radio, TrendingUp, PenLine, Award, Rainbow, Wrench,
    UserCheck, Rocket, Tag,
    // Establishment tags
    Music2, Utensils, Coffee, ChefHat, Flame, Cake, Sandwich,
    Truck, IceCream, Wine, Croissant, Pizza, Fish, Scissors,
    Building2, Lightbulb, Hotel, BedDouble, Calendar, Volleyball, BicepsFlexed, HandMetal, ChessBishop, Popcorn, Car,
    LibraryBig, Glasses, Ghost, Fence, CandyCane, Sun, MicVocal, Video
} from 'lucide-react';

const categoryIconMap = {
    // Event categories
    mic:               Mic,
    partyPopper:       PartyPopper,
    beer:              Beer,
    monitor:           Monitor,
    landmark:          Landmark,
    graduationCap:     GraduationCap,
    trophy:            Trophy,
    briefcase:         Briefcase,
    utensilsCrossed:   UtensilsCrossed,
    shoppingBag:       ShoppingBag,
    sparkles:          Sparkles,
    users:             Users,
    presentation:      Presentation,
    target:            Target,
    palette:           Palette,
    flaskConical:      FlaskConical,
    bookOpen:          BookOpen,
    hammer:            Hammer,
    dumbbell:          Dumbbell,
    brain:             Brain,
    cpu:               Cpu,
    baby:              Baby,
    megaphone:         Megaphone,
    map:               Map,
    music:             Music,
    drum:              Drum,
    radio:             Radio,
    trendingUp:        TrendingUp,
    penLine:           PenLine,
    award:             Award,
    rainbow:           Rainbow,
    wrench:            Wrench,
    userCheck:         UserCheck,
    rocket:            Rocket,
    volleyball:        Volleyball,
    biceps:            BicepsFlexed,
    handMetal:         HandMetal,
    bishop:            ChessBishop,
    popcorn:           Popcorn,
    car:               Car,
    library:           LibraryBig,
    glasses:           Glasses,
    ghost:             Ghost,
    fence:             Fence,
    candy:             CandyCane,
    sun:               Sun,
    vocal:             MicVocal,
    video:             Video,
    // Establishment tags
    music2:            Music2,
    utensils:          Utensils,
    coffee:            Coffee,
    chefHat:           ChefHat,
    flame:             Flame,
    cake:              Cake,
    sandwich:          Sandwich,
    truck:             Truck,
    iceCream:          IceCream,
    wine:              Wine,
    croissant:         Croissant,
    pizza:             Pizza,
    fish:              Fish,
    scissors:          Scissors,
    building2:         Building2,
    lightbulb:         Lightbulb,
    hotel:             Hotel,
    bedDouble:         BedDouble,
    calendar:          Calendar,
};

export function getCategoryIcon(iconKey) {
    return categoryIconMap[iconKey] ?? Tag;
}

/**
 * Resolve the correct icon key for an event object.
 * Priority:
 *  1. el.thumb — if it's a valid icon key (new events)
 *  2. First tag's icon — fallback for existing events with image URLs in thumb
 *  3. 'tag' — absolute default
 */
export function resolveEventIcon(event) {
    if (event?.thumb && categoryIconMap[event.thumb]) {
        return event.thumb;
    }
    const firstTagIcon = event?.tags?.[0]?.icon;
    if (firstTagIcon && categoryIconMap[firstTagIcon]) {
        return firstTagIcon;
    }
    return 'tag';
}
